var filter = function () {
  return function (input) {
    if (input == null || input == undefined || input == 0) {
      return "N/A";
    }
    return (
      {
        retailer_admin: "Admin",
        retailer: "Manager",
        retailer_employee: "Employee",
        group_director: "Group Director",
        finance: "Finance",
      }[input] || ""
    );
  };
};

filter.$inject = [];

tiz.filter("retailerRole", filter);
export default filter;
